// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-j_gL","advertDetailHeaderLocation__value":"c-j_gM"};